// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import TranslatedOption from '../translated-option';

const Placeholder = props => {

    const placeholderOption = (
        <option value=''>
            {props.text}
        </option>
    );

    const translatedPlaceholderOption = (
        <TranslatedOption
            text={props.text}
            value=''
        />
    );

    return props.isTranslated ?
        placeholderOption :
        translatedPlaceholderOption;

};

Placeholder.displayName = 'Placeholder';
Placeholder.propTypes = {
    isTranslated: PropTypes.bool.isRequired,
    text: PropTypes.string.isRequired
};

export default Placeholder;



// WEBPACK FOOTER //
// ./src/shared/components/options-drop-down/placeholder-option.js